import React from "react";

/**
 * Footer global — affiché en bas de toutes les pages (login + interface).
 * Deux lignes centrées en majuscules.
 */
export default function AppFooter() {
  return (
    <footer
      className="w-full bg-white px-4 py-2.5 text-center"
      data-testid="app-footer"
    >
      <p
        className="font-sans text-[10px] uppercase tracking-[0.18em] text-zinc-500"
        data-testid="footer-line-1"
      >
        © 2026 - MAAK FRANCE
      </p>
    </footer>
  );
}
